import { render, staticRenderFns } from "./TravelEdit.vue?vue&type=template&id=08e7f181&scoped=true"
import script from "./TravelEdit.vue?vue&type=script&lang=js"
export * from "./TravelEdit.vue?vue&type=script&lang=js"
import style0 from "./TravelEdit.vue?vue&type=style&index=0&id=08e7f181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7f181",
  null
  
)

export default component.exports